var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 62 2 48.568 2 32 2 15.43 15.431 2 32 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.002 46l-13.33-12.373c-3.563-3.363-3.563-8.764 0-12.128C20.389 19.9 22.72 19 25.15 19c2.43 0 4.76.9 6.476 2.5l.377.36.378-.36c1.715-1.6 4.046-2.5 6.476-2.5 2.43 0 4.76.9 6.476 2.5 3.557 3.365 3.557 8.761 0 12.127L32.002 46z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))));
};
export default SvgHeart;